<template>
    <div class="composer-tabs">
        <slot :toggle="toggle" :active="active" />

        <transition name="fade">
            <slot name="items" :active="active" />
        </transition>
    </div>
</template>

<style>
    .composer-tabs {
    }
</style>

<script>
export default {

    props: {
        default: String
    },

    data: () => ({
        active: ''
    }),

    mounted() {
        this.active = this.default ? this.default : ''
    },

    methods: {
        toggle(name) {
            this.active = name
        },

        close() {
            this.active = ''
        },
    },
}
</script>



// WEBPACK FOOTER //
// src/components/composer/Tabs/Tabs.vue